<template>
  <div>
    <BaseButton primary small @click="showCreateNoteModal">
      {{ $t('contact_notes.create') }}
    </BaseButton>
  </div>
</template>

<script>
import { contactNotesClient } from '@/api/clients';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  methods: {
    showCreateNoteModal() {
      this.$modal.show({
        component: () => import('Components/NoteCreateModal/NoteCreateModal.vue'),
        props: {
          contactId: this.contactId,
          submitAction: this.storeNote,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async storeNote(formData) {
      try {
        await contactNotesClient.store(this.contactId, formData);

        this.$emit('create');

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
